<template>
  <div
    class="zm-radio-group"
    :class="[size ? 'zm-radio-group--' + size : '']"
    role="radiogroup"
    ref="radioGroup"
    @keydown="handleKeydown"
  >
    <div v-if="enterSelect" :id="uid" class="zm-sr-only">
      Press enter or space to select
    </div>
    <slot></slot>
  </div>
</template>
<script>
  import Emitter from '../../mixins/emitter';
  import AriaUtils from '../../utils/aria-utils';

  let _uid = 0;

  function uid() {
    return _uid++;
  }

  export default {
    name: 'ZmRadioGroup',

    componentName: 'ZmRadioGroup',

    inject: {
      ZmFormItem: {
        default: ''
      }
    },

    mixins: [Emitter],

    props: {
      value: [String, Number, Boolean, Array],
      size: {
        type: String,
        default: 'small'
      },
      fill: String,
      textColor: String,
      disabled: Boolean,
      name: String,
      enterSelect: Boolean
    },

    computed: {
      _elFormItemSize() {
        return (this.ZmFormItem || {}).elFormItemSize;
      },
      radioGroupSize() {
        return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      },
      uid() {
        return 'zm-radio-group' + uid();
      }
    },

    created() {
      this.$on('handleChange', value => {
        this.$emit('change', value);
      });

      this.$on('updateRadioUseStatus', _ => {
        this.$nextTick(() => {
          this.refreshRadiosAria();
        });
      });
    },
    mounted() {
      this.refreshRadiosAria();
      this.initObserver();
    },
    methods: {
      handleKeydown(e) { // 左右上下按键 可以在radio组内切换不同选项
        const target = e.target;
        if (!target.type || target.type.toLowerCase() !== 'radio') {
          return;
        }
        const keyCode = e.keyCode;
        const keys = AriaUtils.keys;

        let flag = false;
        switch (keyCode) {
          case keys.space:
          case keys.enter:
            this.setChecked(target);
            flag = true;
            break;
          case keys.left:
          case keys.up:
            this.setCheckedToPreviousItem(target);
            flag = true;
            break;
          case keys.right:
          case keys.down:
            this.setCheckedToNextItem(target);
            flag = true;
            break;
          default:
            break;
        }
        if (flag) {
          e.stopPropagation();
          e.preventDefault();
        }
      },
      setChecked(currentItem, withoutClick) {
        if (!withoutClick) {
          currentItem.click();
        }
        currentItem.focus();
      },
      setCheckedToPreviousItem(currentItem) {
        let index;
        if (currentItem === this.firstRadio) {
          this.setChecked(this.lastRadio, this.enterSelect);
        } else {
          index = this.radios.indexOf(currentItem);
          this.setChecked(this.radios[index - 1], this.enterSelect);
        }
      },
      setCheckedToNextItem(currentItem) {
        let index;
        if (currentItem === this.lastRadio) {
          this.setChecked(this.firstRadio, this.enterSelect);
        } else {
          index = this.radios.indexOf(currentItem);
          this.setChecked(this.radios[index + 1], this.enterSelect);
        }
      },
      getFirstRadio() {
        for (let i = 0; i < this.radios.length; i++) {
          if (!this.radios[i].disabled) {
            return this.radios[i];
          }
        }
        return null;
      },
      refreshRadiosAria() {
        const nodeListRadios = this.$refs.radioGroup.querySelectorAll('[type=radio]');
        this.radios = [];
        for (let i = 0; i < nodeListRadios.length; i++) {
          const radio = nodeListRadios[i];
          !radio.disabled && this.radios.push(radio);
        }
        this.firstRadio = this.getFirstRadio();
        const size = this.radios.length;
        this.lastRadio = this.radios[size - 1];
        // 当radioGroup没有默认选项时，第一个可以选中Tab导航
        if (![].some.call(this.radios, radio => radio.checked) && this.firstRadio) {
          this.firstRadio.tabIndex = 0;
        }
      },
      initObserver() {
        const target = this.$refs.radioGroup;
        const config = { childList: true };
        const cb = (mutationsList) => {
          for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              this.refreshRadiosAria();
            }
          }
        };
        this.Observer = new MutationObserver(cb);
        this.Observer.observe(target, config);
      }
    },
    watch: {
      value(value) {
        this.dispatch('ZmFormItem', 'el.form.change', [this.value]);
      }
    },
    beforeDestroy() {
      this.Observer.disconnect();
    }
  };
</script>

<style lang="scss">
  @import "./style";
</style>
